<!-- 税抜ベース割引（%割引コード適用時）の内訳ブロック -->
<template>
  <div class="flex w-full flex-col gap-2">
    <div class="inline-flex items-end justify-start gap-2 self-stretch">
      <div class="flex-1 justify-start font-Spectral text-sm font-light leading-tight text-light-fg-muted">Pre-tax subtotal</div>
      <div class="justify-start text-right font-Spectral text-sm font-normal leading-tight text-light-fg-muted" data-testid="preTaxSubtotal">{{ preTaxSubtotalDisplay }}</div>
    </div>
    <div class="inline-flex items-end justify-start gap-2 self-stretch">
      <div class="flex-1 justify-start font-Spectral text-sm font-light leading-tight text-light-fg-muted">Discount ({{ benefitValue }}%)</div>
      <div class="justify-start text-right font-Spectral text-sm font-normal leading-tight text-light-fg-muted" data-testid="discountPercentage">- {{ discountDisplay }}</div>
    </div>
    <div class="inline-flex items-end justify-start gap-2 self-stretch">
      <div class="flex-1 justify-start font-Spectral text-sm font-light leading-tight text-light-fg-muted">Taxable amount (excl. tax)</div>
      <div class="justify-start text-right font-Spectral text-sm font-normal leading-tight text-light-fg-muted" data-testid="taxableAmount">{{ taxableAmountDisplay }}</div>
    </div>
    <div class="inline-flex items-end justify-start gap-2 self-stretch">
      <div class="flex-1 justify-start font-Spectral text-sm font-light leading-tight text-light-fg-muted">Tax (10%)</div>
      <div class="justify-start text-right font-Spectral text-sm font-normal leading-tight text-light-fg-muted" data-testid="taxAmount">{{ taxAmountDisplay }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  /** 割引率（%） */
  benefitValue?: number;
  /** 割引前の税抜小計（表示用文字列） */
  preTaxSubtotalDisplay: string;
  /** 割引額（表示用文字列） */
  discountDisplay: string;
  /** 割引後の課税対象額（表示用文字列） */
  taxableAmountDisplay: string;
  /** 消費税額（表示用文字列） */
  taxAmountDisplay: string;
}

defineProps<Props>();
</script>
